import { Component, OnInit, Input, Injector, ViewChild } from '@angular/core';
import { CorreiosService } from '@app/shared/common/correios/correios.service';
import { AppComponentBase } from '@shared/common/app-component-base';
import { NgForm } from '@angular/forms';
import { AppUserAddressDtoType } from '@shared/AppEnums';
import { UserAddressDto, EnterpriseAddressDto } from '@shared/service-proxies/service-proxies';

@Component({
  moduleId: module.id,
  selector: 'addresses',
  templateUrl: './addresses.component.html',
  exportAs: 'addressesComponent'
})
export class AddressesComponent extends AppComponentBase implements OnInit {

  private UserAddressDtoName = UserAddressDto.name;
  private EnterpriseAddressDtoName = EnterpriseAddressDto.name;
  appUserAddressDtoType = AppUserAddressDtoType;

  @Input("addresses") _addresses: any[];
  @Input("addressDto") AddressDto;
  @Input("requiresAnAddress") requiresAn : boolean = true;
  @ViewChild('addressesForm') public addressesForm: NgForm;

  public addresses: any[] = [];
  public brazilStates: any[] = CorreiosService.loadBrazilStates();
  public countries: any[] = CorreiosService.loadCountries();
  public citiesFromState: any[] = [];
  
  countName = 0;

  constructor(
    private _correiosService: CorreiosService,
    injector: Injector
  ) {
    super(injector);
  }

  ngOnInit() {
    
    this.addresses = this._addresses;
    this.loadCitiesFromState();
  }

  addAddress(): void {

    let address = this.newAddress();
    this.addresses.push(address);
  };

  deleteAddress(index: number): void {
    this.addresses.splice(index, 1);
    this.citiesFromState.splice(index, 1);

    if (this.addresses.length == 1 && (this.isUserAddressDto() || this.isEnterpriseAddressDto())) {

      if (this.isUserAddressDto()) {
        this.addresses[0].type = AppUserAddressDtoType.Home;        
      }
      this.addresses[0].isMailing = true;
    }
  };

  loadCitiesFromState() {

    this.addresses.forEach((address, i) => {

      if (this.isBrasil(i)) {
        this._correiosService.loadCities(this.addresses[i].stateAbbreviation)
          .then(cities => {
            this.citiesFromState.push(cities);
          });
      }
      else
        this.citiesFromState.push([]);
    });
  };

  loadCities(index: number) {

    let stateAbbreviation = this.addresses[index].stateAbbreviation;

    if (this.isBrasil(index)) {
      this._correiosService.loadCities(stateAbbreviation)
        .then(cities => {

          this.citiesFromState[index] = cities;
          this.setValueStateName(index);
        });
    }
    else
      this.addresses[index].stateName = stateAbbreviation;
  }

  clearStateAndCity(index: number) {
    this.addresses[index].stateName = "";
    this.addresses[index].stateAbbreviation = "";
    this.addresses[index].city = "";
    this.addresses[index].zipCode = "";
  }

  setValueStateName(index: number) {

    this.brazilStates.forEach(state => {

      if (state.abbreviation == this.addresses[index].stateAbbreviation) {
        this.addresses[index].stateName = state.name;
      }
    });
  }

  // Only a address can be isMailing
  setOneIsMailingAddress(index: number) {

    if (this.addresses[index].isMailing) {

      this.addresses.forEach((address, i) => {
        if (i != index)
          address.isMailing = false;
      });
    }
  };

  canEditIsMailingAddress(index: number) {
    return this.addresses.length > 0 && this.addresses[index].isMailing == false;
  }

  searchZipCode(index: number) {

    let zipCode = this.addresses[index].zipCode;

    if (zipCode && zipCode.length >= 8) {

      this._correiosService.searchByPostalCode(zipCode).then(result => {

        let data = result[0];

        if (!!data) {
          this.addresses[index].city = data.Municipio.toUpperCase();
          this.addresses[index].complement = data.Complemento.toUpperCase();
          this.addresses[index].district = data.Bairro.toUpperCase();
          this.addresses[index].logradour = data.Logradouro.toUpperCase();
          this.addresses[index].stateAbbreviation = data.Estado.toUpperCase();
          this.addresses[index].stateName = data.Estado.toUpperCase();
          this.addresses[index].countryName = 'BRASIL';
        }

        if ((this.isUserAddressDto() || this.isEnterpriseAddressDto()) && this.addresses.length == 1) {
          this.addresses[index].isMailing = true;
        }

        this.loadCities(index);
      });
    }
  };

  isBrasil(index: number): boolean {
    return this.addresses[index].countryName == 'BRASIL';
  }

  newAddress() {

    let address = new this.AddressDto();
    address.countryName = 'BRASIL';
    address.id = this.countName--;

    
    if (this.isUserAddressDto() || this.isEnterpriseAddressDto()) {

      if (this.addresses.length == 0) {

        if (this.isUserAddressDto()) {
          address.type = AppUserAddressDtoType.Home;
        }
        address.isMailing = true;
      }
      else {
        if (this.isUserAddressDto()) {
          address.type = AppUserAddressDtoType.Business;
        }
        address.isMailing = false;
      }
    }

    return address;
  }

  isUserAddressDto(): boolean {
    return !!this.AddressDto && this.AddressDto.name == this.UserAddressDtoName;
  }

  isEnterpriseAddressDto(): boolean {
    return !!this.AddressDto && this.AddressDto.name == this.EnterpriseAddressDtoName;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/addresses/addresses/addresses.component.ts